// Author LiangGangQiang
// Date 2021-08-25 13:58:14

import * as model from "@/model/sithMes/prd/SithMesPrdPpHeaderInfoModifyTypeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpHeaderInfoModifyType(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesPrdPpHeaderInfoModifyType',
        modelFilter: model.filter
    })
    .buildStore()
